import { TransferStartResponse } from "@/common/types";
import {
	TransferToIvrRequest,
	TransferDestination,
} from "@/components/organisms/interactionTransferToIvr/types";
import { Client, Controller, Endpoint, mapUrl } from "@/repository";

export const getColdTransferToIvrDestinations = (): Promise<
	TransferDestination[]
> => {
	const url = mapUrl(
		Controller.TransferDestinations,
		Endpoint.TransferIvrDestinations
	);
	return Client.instance.get(url);
};

export const startTransferIvr = (
	transferToIvr: TransferToIvrRequest
): Promise<TransferStartResponse> => {
	const url = mapUrl(Controller.AgentCall, transferToIvr.warm ? Endpoint.WarmTransferIvr : Endpoint.ColdTransferIvr);
	return Client.instance.post(url, transferToIvr);
};